var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.986328,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.9863,
    r: 30,
    fill: "#F6AE2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4137 33.4142C51.1947 32.6332 51.1947 31.3668 50.4137 30.5858C49.6327 29.8047 48.3663 29.8047 47.5853 30.5858L39.5005 38.6706L31.4157 30.5858C30.6346 29.8047 29.3683 29.8047 28.5872 30.5858C27.8062 31.3668 27.8062 32.6332 28.5872 33.4142L36.672 41.499L28.5858 49.5853C27.8047 50.3663 27.8047 51.6327 28.5858 52.4137C29.3668 53.1947 30.6332 53.1947 31.4142 52.4137L39.5005 44.3275L47.5867 52.4137C48.3678 53.1947 49.6341 53.1947 50.4151 52.4137C51.1962 51.6327 51.1962 50.3663 50.4151 49.5853L42.3289 41.499L50.4137 33.4142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelYellow);
export default __webpack_public_path__ + "static/media/CancelYellow.57f3d8bc9e55751b6cf1a6071b19f4f6.svg";
export { ForwardRef as ReactComponent };